import { render, staticRenderFns } from "./UpcomingEvents.vue?vue&type=template&id=5fcaf2d1"
import script from "./UpcomingEvents.vue?vue&type=script&lang=js"
export * from "./UpcomingEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports